export const SELECTED_SIDEBAR_ITEM = 'selectedSidebarItem';
